import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from './Layout';
import { getApiUrl } from './config';

function StockReport() {
    const [products, setProducts] = useState([]);

    const handleExportPdf = () => {
        window.print();
    };

    useEffect(() => {
        const fetchProducts = async () => {
            try {
                const res = await axios.get(`${getApiUrl()}/products`);
                setProducts(res.data);
            } catch (err) {
                console.error(err);
            }
        };
        fetchProducts();
    }, []);

    return (
        <Layout>
            <div className="container mt-4">
                <h2>Stock Report</h2>
                <div className="mb-3 no-print">
                    <button type="button" className="btn btn-outline-dark" onClick={handleExportPdf}>
                        Export PDF
                    </button>
                </div>
                <div className="table-responsive">
                    <table className="table table-striped">
                        <thead>
                            <tr>
                                <th>Product Name</th>
                                <th>Category</th>
                                <th>Godown Qty</th>
                                <th>Godown Weight</th>
                                <th>Unit</th>
                                <th>Price</th>
                            </tr>
                        </thead>
                        <tbody>
                            {products.map(p => (
                                <tr key={p.id}>
                                    <td>{p.name}</td>
                                    <td>{p.category}</td>
                                    <td className={(Number(p.godown_qty ?? p.stock) || 0) < 10 ? 'text-danger fw-bold' : ''}>{p.godown_qty ?? p.stock}</td>
                                    <td>{parseFloat(p.godown_weight || 0).toFixed(2)}</td>
                                    <td>{p.unit}</td>
                                    <td>{p.price}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        </Layout>
    );
}

export default StockReport;
